import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import QuoteResource from './QuoteResource';
import axios from 'axios';

export default class QuotesResource extends BaseResource {
  constructor() {
    super({ url: '/api/quotes' });
  }

  list(quoteSetId, params = { size: 10 }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `/api/quote_sets/${quoteSetId}/quotes${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listPropertyQuotes(id, params) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `/api/properties/${id}/reconciliations${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data, quoteSetId) {
    return super
      .post(data, { url: `api/quote_sets/${quoteSetId}/quotes` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  quote(quoteId) {
    return new QuoteResource(`${this.url}/${quoteId}`);
  }

  uploadAttachment(url, file) {
    return axios
      .put(url, file, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': file.type,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
